import { render, staticRenderFns } from "./PwaInstall.vue?vue&type=template&id=d53bc3e0&scoped=true&"
import script from "./PwaInstall.vue?vue&type=script&lang=js&"
export * from "./PwaInstall.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstall.vue?vue&type=style&index=0&id=d53bc3e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../explorakit/vue-explorakit/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53bc3e0",
  null
  
)

export default component.exports